import axiosInstance from "@/lib/axios";

export interface uploadResponse {
    status: string;
    imported_answers: number;
}

export const uploadStudentAnswers = async (
    userId: string | number,
    simulationId: string | number,
    file: File,
): Promise<uploadResponse> => {
    const formData = new FormData();
    formData.append("file", file);

    const url = `/reports/manage/student/${userId}/simulation/${simulationId}/answers/upload/`;

    const { data } = await axiosInstance.post<uploadResponse>(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
};
